module.exports = __webpack_public_path__ + "static/media/ux.8be146f9.png";